.markdown {
  height: 100%;
  padding: var(--mantine-spacing-md);
  overflow: auto;
}

.markdown-content {
  line-height: 1.6;
}
